export default "__VITE_ASSET__Bt$8mm2q__"